import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProformaModalService } from 'src/app/services/proforma-modal/proforma-modal.service';
import { Proforma } from 'src/app/pages/sales/proforma/proforma.model';
import { GeneralService } from 'src/app/services/general/general.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';


@Component({
  selector: 'app-proforma-one',
  templateUrl: './proforma-one.component.html',
  styleUrls: ['./proforma-one.component.scss']
})
export class ProformaOneComponent implements OnInit, OnDestroy {

  selectedProforma: Proforma | null = null;
  private subscription: Subscription = new Subscription();
  isGeneratingPDF: boolean = false;
  settings:any;

  constructor(
    private proformaModalService: ProformaModalService,
    private _generalService: GeneralService,
    private _globalService : GlobalStateService
  ) { }


  ngOnInit(): void {
    // Subscribe to selected proforma changes
    this.subscription.add(
      this.proformaModalService.selectedProforma$.subscribe(proforma => {
        if (proforma) {
          this.selectedProforma = proforma;
          console.log('Proforma received in modal:', proforma);
        }
      })

    );
      this.loadSettings();


    // Setup modal listener to handle data when modal opens
    this.setupModalListener();
  }

  loadSettings(): void {
    this._globalService.GetSetting().subscribe((res: any) => {
      this.settings = res.contacts?.english;
    });
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_proforma_preview');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        console.log('Proforma modal opened, checking for data...');
        // Get proforma from service if not already set
        const serviceProforma = this.proformaModalService.getSelectedProforma();
        if (serviceProforma && !this.selectedProforma) {
          this.selectedProforma = serviceProforma;
          console.log('Using proforma from service:', serviceProforma);
        }
      });
    }
  }

  // Helper method to format date
  formatDate(dateString: string | undefined): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  }

  // Helper method to get vehicle price
  getVehiclePrice(): string {
    if (this.selectedProforma && this.selectedProforma.items && this.selectedProforma.items.length > 0) {
      const vehicleItem = this.selectedProforma.items[0];
      return vehicleItem.amount.toLocaleString();
    }
    return '5,000';
  }

  // Helper method to get total amount
  getTotalAmount(): string {
    if (this.selectedProforma && this.selectedProforma.items && this.selectedProforma.items.length > 0) {
      const total = this.selectedProforma.items.reduce((sum, item) => sum + item.amount, 0);
      return total.toLocaleString();
    }
    return '5,000';
  }

  // Helper method to get vehicle image
  getVehicleImage(vehicle: any): string {
    if (vehicle && vehicle.pictures && vehicle.pictures.length > 0) {
      return vehicle.pictures[0];
    }
    return 'assets/media/stock/600x400/img-1.jpg'; // Fallback image
  }

  // Helper method to get individual vehicle price
  getIndividualVehiclePrice(index: number): string {
    if (this.selectedProforma && this.selectedProforma.items && this.selectedProforma.items[index]) {
      return this.selectedProforma.items[index].amount.toLocaleString();
    }
    return '5,000';
  }

  // TrackBy function for vehicle loop
  trackByVehicleId(index: number, vehicle: any): string {
    return vehicle._id || vehicle.chassis_no || index.toString();
  }

  // Helper method to get vehicle count
  getVehicleCount(): number {
    if (this.selectedProforma && this.selectedProforma.vehicles) {
      return this.selectedProforma.vehicles.length;
    }
    return 0; // Return 0 when no vehicles to trigger fallback display
  }

  // Helper method to get vehicle count for display (shows 1 when no data for totals)
  getDisplayVehicleCount(): number {
    const count = this.getVehicleCount();
    return count > 0 ? count : 1; // Show 1 in totals even when no real data
  }

  // Method to handle print functionality using GeneralService
  printProforma(): void {
    if (!this.selectedProforma || !this.selectedProforma._id) {
      console.error('No proforma selected or missing ID');
      alert('Error: No proforma selected. Please try again.');
      return;
    }

    this.isGeneratingPDF = true;

    // Prepare data for API call
    const data = {
      order_id: this.selectedProforma._id,
      proforma_no: "one",
      type: "proforma-one"
    };

    console.log('Generating PDF for proforma:', data);

    // Call the generatePDF service
    this._generalService.generatePDF(data).subscribe({
      next: (res: any) => {
        console.log('PDF generation response:', res);
        if (res && res.data && res.data.url) {
          // Download the PDF
          this.downloadPDF(res.data.url);

          // PDF generated successfully
          this.isGeneratingPDF = false;
          console.log('PDF generated and downloaded successfully');
        } else {
          console.error('Invalid response format:', res);
          this.isGeneratingPDF = false;
          alert('PDF generation failed. No URL received.');
        }
      },
      error: (error: any) => {
        console.error('Error generating PDF:', error);
        this.isGeneratingPDF = false;
        alert('Error generating PDF. Please try again.');
      }
    });
  }

  // Helper method to download PDF
  private downloadPDF(url: string): void {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';

    // Create filename with proforma number
    const filename = `Proforma_Invoice_${this.selectedProforma?.order_number || 'P-19138'}_${new Date().toISOString().split('T')[0]}.pdf`;
    link.download = filename;

    // Trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    console.log(`Downloaded PDF: ${filename}`);
  }

}
